import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { VehicleHeader } from '@motorway/motorway-storybook-cra';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { usePageTransitionState } from 'Utilities/animation';

import { ComponentsWrapper } from 'Layout';

import PageLoader from '../../../../components/transitions/PageLoader/PageLoader';
import Texts from '../../../../texts.json';
import Loader from '../valuations/components/Loader';

import styles from './VehicleHeaderWrapper.scss';

const T = new MDText(Texts);

const VehicleHeaderWrapper = ({
  animate,
  isCognitoVehicleHeader = false,
  loading,
}) => {
  const { vehicleLookupActions, vehicleLookupState: vehicle } = useContext(VehicleLookupContext);
  const { animate: transitView, animateFromNewHomePage } = usePageTransitionState();

  return (
    <>
      {
        (vehicle?.id) ? (
          <>
            <div
              className={cx(styles.vehicleHeader, {
                [styles.animated]: animate,
                [styles.animateNotFromNewHomePage]: animate && !animateFromNewHomePage,
                [styles.open]: transitView,
              })}
            >
              <div className={styles.vehicleInner}>
                <VehicleHeader
                  showBody
                  showColour
                  showFuel
                  showMileage
                  showYear
                  className={cx({
                    [styles.newGutterSpaces]: isCognitoVehicleHeader,
                  })}
                  enquiry={vehicle.enquiry}
                  expanded={false}
                  prependDetailsList={
                    [<Link onClick={() => vehicleLookupActions.remove()} to="/">{T.translate('vehicleView.changeVehicleLinkText')}</Link>]
                  }
                  vehicle={vehicle}
                  wrapperClassName={cx({
                    [styles.headerAnimated]: animate,
                    [styles.animateNotFromNewHomePage]: animate && !animateFromNewHomePage,
                    [styles.headerHidden]: transitView && !animate,
                  })}
                />
              </div>
            </div>
            {
              loading && (
              <ComponentsWrapper className={cx({ [styles.loaderHidden]: transitView && !animate })}>
                <Loader />
              </ComponentsWrapper>
              )
            }
          </>
        ) : (
          <>
            { loading && <PageLoader /> }
          </>
        )
      }
    </>
  );
};

VehicleHeaderWrapper.defaultProps = {
  animate: false,
  isCognitoVehicleHeader: false,
  loading: false,
};

VehicleHeaderWrapper.propTypes = {
  animate: PropTypes.bool,
  isCognitoVehicleHeader: PropTypes.bool,
  loading: PropTypes.bool,
};

export default VehicleHeaderWrapper;
